/**
 * HR Employee Export page — the "Export employees" tab of the Import & Export
 * hub (/hr/import-export?tab=employees-out).
 *
 * Downloads the employee directory as a CSV in the same layout the import
 * reads, so HR can pull the master data out and load it back unchanged. The
 * whole surface is the export card; it lives beside "Import Employees".
 */

import { PageHead } from '../components/primitives/PageHead'
import { HrAccessGuard } from '../components/hr/HrAccessGuard'
import { EmployeeExportCard } from './hr-employees-export/EmployeeExportCard'

export function HrEmployeeExportPage(): JSX.Element {
  return (
    <HrAccessGuard>
      <PageHead
        eyebrow="HR"
        title="Export employees"
        subtitle="Download the employee directory as a CSV in the same layout the import reads, so you can edit it and load it back in unchanged."
      />
      <EmployeeExportCard />
    </HrAccessGuard>
  )
}
